<template>
  <div class="diplomas">
      <div v-if="errorLogin == null">
        <div class="seccion-titulo" id="contenidoPrincipal">
           {{ $t('diplos_titu_certi', {textoDiplomasCap: $parent.getTextoDiplomasCap, textoDiplomas: $parent.getTextoDiplomas}) }}
        </div>   
        <div class="seccion-parrafo-nivel-1">
          {{ $t('diplos_info', {nombreApp: $parent.getNombreApp}) }}
        </div> 
        <div class="seccion-parrafo-nivel-2">
           {{ $t('diplos_info2', {nombreApp: $parent.getNombreApp}) }}
        </div>    
        <div class="seccion-subtitulo">
          {{ $t('diplos_generados', {textoDiplomas: $parent.getTextoDiplomasCap}) }}
        </div>   

        <div v-if="numDiplomas==0">
            <div class="msg-warn">
              <div class="msg-warn-title">{{ $t('diplos_empty', {textoDiplomas: $parent.getTextoDiplomas}) }}</div>
            </div>
        </div>  

        <div v-if="numDiplomas>0">
          <DataTable
            :value="diplomas" 
            :autoLayout="true"
            :paginator="true"
            :rows.sync="numFilas"
            :totalRecords="numDiplomas"
            :rowsPerPageOptions="rowsPerPageOptions"
            :loading="loading"
            :lazy="true"
            @page="onPage($event)"
            @sort="onSort($event)"
            :filters="filters"
            class="p-datatable-responsive"
            sortField="fechasol" :sortOrder="-1"
            >
            <Column field="actividad" v-bind:header="$t('diplos_actividad')" :sortable="true" sortField="titulo">
              <template #body="slotProps">
                {{ slotProps.data.actividad }}  
                <br />
                 <small> ({{ new Date(slotProps.data.fechaini) | dateFormat('DD/MM/YYYY') }} - {{ new Date(slotProps.data.fechafin) | dateFormat('DD/MM/YYYY') }})</small>
              </template>  
            </Column>
            
            <Column field="fechasol" v-bind:header="$t('diplos_fechasol')" :sortable="true" headerStyle="width: 20%" headerClass="hidden-xs" bodyClass="hidden-xs">
              <template #body="slotProps">
                {{ new Date(slotProps.data.fechasol) | dateFormat('DD/MM/YYYY') }}  
              </template>      
            </Column>

            <Column header="" :exportable="false" headerStyle="width: 20%; text-align:center;" bodyStyle="text-align:center;"  >  
              <template #body="slotProps">
                <!-- CASI-6443 -->
                  <div class="icono-danger" v-if="slotProps.data.tanda != '-1' || slotProps.data.pidDocumento==null">
                    <i class="fas fa-exclamation-circle fa-2x"></i>
                  </div>
                  <div v-else>
                    <Button icon="pi pi-file-pdf" class="p-button-rounded p-button-danger p-mr-2" @click="openModalDescargar(slotProps.data)" v-tooltip.top="$t('diplos_descarga', {textoDiploma: $parent.getTextoDiploma})"/>
                    <Button icon="pi pi-envelope" class="p-button-rounded p-button-danger p-mr-2 boton-suplantado" @click="openModalCorreo(slotProps.data)" v-if="$parent.isAdmin" v-tooltip.top="$t('diplos_correo', {textoDiploma: $parent.getTextoDiploma})"/>
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-mr-2 boton-suplantado" @click="openModalAnular(slotProps.data)" v-if="$parent.isAdmin" v-tooltip.top="$t('diplos_anular', {textoDiploma: $parent.getTextoDiploma})"/>
                  </div>
              </template>
            </Column>
          </DataTable>
        
          <div class="msg-info" v-if="diplomaAntiguo">
            <div class="msg-info-title"><i class="fas fa-exclamation-circle"></i> {{ $t('diplos_infodip', {textoDiploma: $parent.getTextoDiploma, nombreApp: $parent.getNombreApp}) }} </div>
          </div>
          
        </div>  

        <Dialog v-bind:header="$t('diplos_dipgen', {textoDiploma: $parent.getTextoDiploma})" :visible.sync="displayModalDescargar" :style="{width: '50vw'}" :modal="true">
            <p class="p-m-0 seccion-contenido-left">
                {{mensajeDescarga}}
            </p>
            <br/>
            <template #footer>
                <Button v-bind:label="$t('aceptar')" icon="pi pi-check" @click="closeModalDescargar" class="p-button-danger"/>
            </template>
        </Dialog>      

        <Dialog v-bind:header="$t('diplos_titucorreo')" :visible.sync="displayModalCorreo" :style="{width: '40vw'}" :modal="true">
            <p class="p-m-0 seccion-contenido-left">
                {{ $t('diplos_infocorreo', {textoDiploma: $parent.getTextoDiploma}) }}
                <br/>
                <br/>
                <br/>
                <div class="contenido-codigo">
                  {{ $t('envio_correo_estudiante_info', {textoDiploma: $parent.getTextoDiploma}) }}
                </div>
            </p>
            <br/>
            <template #footer>
                <p>{{ $t('diplos_pregcorreo') }}</p>
                <Button label="No" icon="pi pi-times" @click="closeModalCorreo" class="p-button-text p-button-danger"/>
                <Button v-bind:label="$t('si')" icon="pi pi-check" @click="enviarCorreo()" autofocus class="p-button-danger" />

            </template>
        </Dialog>      

        <Dialog v-bind:header="$t('diplos_anula', {textoDiploma: $parent.getTextoDiploma})" :visible.sync="displayModalAnular" :style="{width: '50vw'}" :modal="true">
            <p class="p-m-0 seccion-contenido-left">
              {{ $t('diplos_infoanula', {textoDiploma: $parent.getTextoDiploma}) }}
              <br/>
              <br/>

              <!-- CURSOS-1151 -->
                <label for="motivoAnulacion">{{ $t('motivo_anulacion') }}</label>
                <br/><br/>
                <Textarea
                  type="text"
                  id="motivoAnulacion"
                  name="motivoAnulacion"
                  v-model="motivoAnulacion"
                  :class="{ 'p-invalid' : this.obligatorioMotivoAnulacion == true}"
                  rows="1" cols="50"
                  :autoResize="true"
                  :maxlength=100
                  autofocus
                />
                <div v-if="this.motivoAnulacion != null" class="p-m-0 seccion-contenido-left">
                  ({{this.motivoAnulacion.length}}/100)
                </div>
           </p>
            <template #footer>
                <p>{{ $t('continuar_preg') }}</p>                
                <Button label="No" icon="pi pi-times" @click="closeModalAnular" class="p-button-text p-button-danger" />
                <Button v-bind:label="$t('si')" icon="pi pi-check" @click="anular()"  class="p-button-danger" />
            </template>
        </Dialog>      
    </div>
    <div v-if="errorLogin != null">
      <div class="msg-warn">
        <div class="msg-warn-title">
            {{ $t('err_acceso') }}
            <br/>
            <span @click="$parent.logoutSession()" class="enlace-span">
                {{ $t('err_url') }}
            </span>
          </div>
      </div>
    </div>

    <Toast></Toast>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import Textarea from 'primevue/textarea';
import ServicioRest from "@/services/ServicioRest";
import Button from "primevue/button";
import Toast from "primevue/toast";
import Dialog from 'primevue/dialog';
import store from "../store"
import pdfUtil from "@/util/pdfUtil.js";
import pdf from "vue-pdf";

export default {
  data() {
    return {
      diplomas: null,
      numDiplomas: 1,
      pagina: 0,
      numFilas: 10,
      loading: false,
      orden: 0,
      ordenarPor: null,
      rowsPerPageOptions: [5, 10, 50],
      filters: {},
      diplomaPdf: null,
      displayModalDescargar: false,
      displayModalCorreo: false,
      displayModalAnular: false,
      filaSeleccionada: null,
      errorLogin: null,
      mensajeDescarga: "El diploma/certificado se ha descargado, revise la carpeta de descargas.",
      diplomaAntiguo: false,
      motivoAnulacion: null, // CURSOS-1151
      obligatorioMotivoAnulacion: false, // CURSOS-1151
    };
  },
  servicioRest: null,
  created() {
    this.servicioRest = new ServicioRest();
  },
  mounted() {
    this.actualizarTabla();
  },
  methods: {
    onPage(event) {
      this.pagina = event.page;
      this.actualizarTabla();
    },
    onSort(event) {
      // Campos: event.sortField, event.sortOrder (1 ascendente, -1 descendente)
      this.orden = event.sortOrder;
      this.ordenarPor = event.sortField;
      this.actualizarTabla();
    },
    actualizarTabla() {
      this.loading = true;
      // Accedemos al getter poniendo especificando el módulo / getter
      let token = store.getters["token/getToken"];
      this.servicioRest.diplomasPaginados(token,this.pagina, this.numFilas, this.orden, this.ordenarPor, this.getFiltros()).then((response) => {
      if (response.status == 'OK') {
          this.diplomas = response.diplomasPg.content;
          this.numDiplomas = response.diplomasPg.totalElements;
          for (var i=0; i<this.numDiplomas;i++){
            //CASI-6443
            if (this.diplomas[i] && (this.diplomas[i].tanda != '-1' || this.diplomas[i].pidDocumento==null)) {
              this.diplomaAntiguo=true;
              break;
          }};             
          this.loading = false;
        }else{
          this.errorLogin = "El usuario o clave introducidos son incorrectos";
        }
      }).catch((error) => {
          this.$toast.add({ severity: "error", summary: this.$t('error'), detail: 'Error al cargar el diploma', life: 3000 });
          console.log(error);
      });
    },
    getFiltros() {
      var str = "";
      // Obtenemos el array de claves para sacar su longitud
      for (var i = 0; i < Object.keys(this.filters).length; i++) {
        var key = Object.keys(this.filters)[i];
        // Ponemos la clave y su valor, sustituyendo los espacios por +, en el formato que se pasará a la URL
        str += key + "=" + this.filters[key].replace(" ", "+") + "&";
      }
      // Eliminamos el último &
      str = str.substring(0, str.length - 1);
      return str;
   },
    openModalDescargar(value) {
        this.displayModalDescargar = true;
        this.descargarDiploma(value);
    },
    closeModalDescargar() {
        this.displayModalDescargar = false;
    },
    openModalCorreo(value) {
        this.filaSeleccionada = value,
        this.displayModalCorreo = true;
    },
    closeModalCorreo() {
        this.displayModalCorreo = false;
    },
    openModalAnular(value) {
        this.filaSeleccionada = value,
        this.motivoAnulacion = null,
        this.obligatorioMotivoAnulacion = false,
        this.displayModalAnular = true;
    },
    closeModalAnular() {
        this.displayModalAnular = false;
    },
  descargarDiploma(value) {
      // Accedemos al getter poniendo especificando el módulo / getter
      let token = store.getters["token/getToken"];
      this.servicioRest.diplomaPdf(value.cucod,token).then((response) => {
        if (response.status == 'OK') {
          if (response.diplomaPdf == null) {
            this.mensajeDescarga = this.$t('diplos_infodip', {nombreApp: $parent.getNombreApp, textoDiploma: $parent.getTextoDiploma});
          } else {
              this.diplomaPdf = pdfUtil.base64DecToArr(response.diplomaPdf).buffer;
              this.diplomaPdf = new Blob([this.diplomaPdf], { type: "application/pdf" });
              this.mensajeDescarga = this.$t('diplos_dipdescarga');
              // IE doesn't allow using a blob object directly as link href
              // instead it is necessary to use msSaveOrOpenBlob
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(this.diplomaPdf);
                return;
              }
              // For other browsers:
              // Create a link pointing to the ObjectURL containing the blob.
              const data = window.URL.createObjectURL(this.diplomaPdf);
              var link = document.createElement("a");
              link.href = data;
              link.download = "diploma.pdf";
              link.click();
              setTimeout(function() {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 100);
          }
        
        }
      }).catch((error) => {
          this.$toast.add({ severity: "error", summary: this.$t('error'), detail: this.$t('diplos_dipdescargaerror'), life: 3000 });
      });


    },

      //enviamos un correo al alumno con el diploma adjunto. 
    enviarCorreo() {
      var value = this.filaSeleccionada;
      // Accedemos al getter poniendo especificando el módulo / getter
      let token = store.getters["token/getToken"];
      this.servicioRest.correoAlumno(value.cucod,token).then((response) => {
        if (response.accionCompletada) {
            this.$toast.add({ severity: "success", summary: this.$t('diplos_correoenv'), detail: this.$t('diplos_correook'), life: 3000 });
        } else {
            this.$toast.add({ severity: "error", summary: this.$t('error'), detail: this.$t('diplos_correoerror'), life: 3000 });
        }
        this.closeModalCorreo();
      }).catch((error) => {
          this.$toast.add({ severity: "error", summary: this.$t('error'), detail: this.$t('diplos_correoerror'), life: 3000 });
      });
    },
    anular() {
      var value = this.filaSeleccionada;
      // CURSOS-1151
      if (this.motivoAnulacion === null || this.motivoAnulacion.length <= 0) {
        this.$toast.add({ severity: "warn", summary: this.$t('warn'), detail: this.$t('motivo_anulacion_warn'), life: 3000 });
        this.obligatorioMotivoAnulacion = true;
        return;
      }
      
      // Accedemos al getter poniendo especificando el módulo / getter
      let token = store.getters["token/getToken"];
      var diplomaContext = {cursosDiplomas: {
        id: {cuCod: value.cucod, identificador: value.identificador}, 
        estado: "G", userSolicita: value.identificador, fechaSolicita: (new Date()),
        fechaAnula: (new Date()), pidDocumento : value.pidDocumento, observaciones: this.motivoAnulacion},
       }; 

      this.servicioRest.anulaDiploma(diplomaContext,token).then((response) => {
        if (response.accionCompletada) {
          this.$toast.add({ severity: "success", summary: this.$t('diplos_dipanulado', {textoDiploma: this.$parent.getTextoDiploma}), detail: this.$t('diplos_dipanuladook', {textoDiploma: this.$parent.getTextoDiploma}), life: 3000 });
          this.actualizarTabla();
        } else {
          this.$toast.add({ severity: "error", summary: this.$t('error'), detail: this.$t('diplos_anulaerror', {textoDiploma: this.$parent.getTextoDiploma}), life: 3000 });
        }
        this.closeModalAnular();
        this.$router.push({ name: 'Diplomas'})
      }).catch((error) => {
          this.$toast.add({ severity: "error", summary: this.$t('error'), detail: this.$t('diplos_anulaerror', {textoDiploma: this.$parent.getTextoDiploma}), life: 3000 });
      });
    },
  },
  components: {
    DataTable,
    Column,
    InputText,
    Textarea,
    Button,
    Toast,
    Dialog,
    pdf,
  },
};
</script>
